// extracted by mini-css-extract-plugin
export default {"intro":"About_intro__Bo3Zy","name":"About_name__2gLBq","hire":"About_hire__5J3eP","icons":"About_icons__mbqyz","right":"About_right__eI1C9","my_img":"About_my_img__Yd+WU"};